import { Component } from '@poa/core';
import { getProfileIcon } from '../../icons/profile';
import React from 'react';
import moment from 'moment';

import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer } from 'recharts';


const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0) {
        return (
            <div className="chart-tooltip">
                <h5>{label}</h5>
                <br />
                <h4>$ {payload[0].value}</h4>
            </div>
        );
    } else {
        return null;
    }
}

const CustomizedAxisTick = props => {
    const { x, y, payload } = props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text 
        x={0} 
        y={0} 
        dy={16} 
        textAnchor="end" 
        fill="#52525B"
        color="#52525B"
        fontSize="12"
        fontWeight="400"
        >
          {moment(payload.value, "DD.MM.YYYY").format('MMM')}
        </text>
      </g>
    );
  };


class GeneralFinanceProfile extends React.Component {
    store; // injected by Poa
    router; // injected by Poa

    handleAllTransactions = () => {

        const { setDates, changeSearch } = this.actions.statisticsActions;
        const { selectedProfile } = this.store.generalProfile

        const lastPaymentDate = moment(selectedProfile.payments.lastPaymentDate, "YYYYMMDD")
        
        setDates(lastPaymentDate, lastPaymentDate)
        changeSearch(selectedProfile.id);

        this.router.push('/finances')
    }

    render() {

        const { selectedProfile } = this.store.generalProfile;

        return (
            <div className='general_info__content'>
                {
                    selectedProfile.id ?
                        <>
                            <div className='name-row'>
                                <div>
                                    <div className='title-name'>
                                        {selectedProfile.name || 'Empty Name'}
                                    </div>
                                </div>
                            </div>
                            <div className='finance-row'>
                                <div className='info-card'>
                                    <div className='info-title'>Total</div>
                                    <div className='info-value'>$ {selectedProfile.payments.totalSum}</div>
                                </div>
                                <div className='info-card'>
                                    <div className='info-line-row'>
                                        <div className='info-title'>Last</div>
                                        <div className='info-title__right'>{selectedProfile.payments.lastPaymentDate}</div>
                                    </div>
                                    <div className='info-value__black'>$ {selectedProfile.payments.lastPayment}</div>
                                </div>
                                <div className='info-card'>
                                    <div className='info-title'>Avarage</div>
                                    <div className='info-value__black'>$ {selectedProfile.payments.avaragePayment}</div>
                                </div>
                                <div className='info-card'>
                                    <div className='info-title'>Transactions</div>
                                    <div className='info-value__black'>{selectedProfile.payments.totalQty}</div>
                                </div>
                            </div>
                            <div className='finance-row'>
                                <div className='info-chart-card'>
                                    <div className='info-title'>Payments</div>
                                    <div className='info-chart'>
                                        <ResponsiveContainer minWidth={350} height={350}>
                                            <AreaChart
                                                data={selectedProfile.payments.profitData}
                                                margin={{
                                                    top: 2,
                                                    right: 0,
                                                    left: 10,
                                                    bottom: 0,
                                                }}
                                            >
                                                <XAxis dataKey="date" tick={<CustomizedAxisTick />} />
                                                <Tooltip content={<CustomTooltip />} />
                                                <Area
                                                    type="monotone"
                                                    dataKey="total"
                                                    stroke="#5B668D"
                                                    fill="#F5F7FF" />
                                            </AreaChart>
                                        </ResponsiveContainer>
                                    </div>

                                </div>
                            </div>
                            <div className='finance-row'>
                                <div className='info-chart-card'>
                                    <div className='info-header'>
                                        <div className='info-title'>Transactions history</div>
                                        <div className='info-title_right' onClick={this.handleAllTransactions}>
                                                See all transactions {'>'}
                                        </div>
                                    </div>
                                    <div className='card-table-header'>
                                        <div className='table-header-name'>AccountID</div>
                                        <div className='table-header-name'>Type</div>
                                        <div className='table-header-name'>Amount</div>
                                        <div className='table-header-name'>Date</div>
                                    </div>
                                    <ul className='card-table'>
                                        {selectedProfile.payments.lastPayments.map((payment, idx) => {
                                            return (
                                                <li key={idx}>
                                                    <div className='table-row-name'>{payment.accountID}</div>
                                                    <div className='table-row-name'>{payment.type}</div>
                                                    <div className='table-row-value'>$ {payment.amount}</div>
                                                    <div className='table-row-name'>{payment.date}</div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </>
                        :
                        <div className='main-row'>
                            <div className='no-profile-found-text'>
                                {getProfileIcon('noUser')}
                                Профиль не найден
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['general-finance-profile'] })(GeneralFinanceProfile);